import React from "react"
import PropTypes from "prop-types"
import BtnPrimary from '../../form_sections/BtnPrimary'
import BtnSecondary from '../../form_sections/BtnSecondary'
import SettingsLongTextInput from '../../form_sections/SettingsLongTextInput'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'


class PauseOrCancelAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pauseAccountOpen: false,
      unpauseAccountOpen: false,
      cancelAccountOpen: false,
      cancelReason: '',
      accountCancelled: false,
      deleteAccountOpen: false,
      deleteSuccessful: false
    }
    this.pauseAccount = this.pauseAccount.bind(this)
    this.togglePause = this.togglePause.bind(this)
    this.unpause = this.unpause.bind(this)
    this.toggleCancel = this.toggleCancel.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.deleteUser = this.deleteUser.bind(this)
  }

  updateUser(data) {
    $.ajax({
      url: `../updateUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {

      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  pauseAccount() {
    this.togglePause()
    let data = {
      user: {
        status: 'Travelling'
      }
    }

    this.updateUser(data)
  }

  togglePause() {
    this.setState({
      pauseAccountOpen: !this.state.pauseAccountOpen
    })
  }

  unpause() {
    this.setState({
      pauseAccountOpen: false,
      unpauseAccountOpen: true
    })
    let data = {
      user: {
        status: 'Active'
      }
    }

    this.updateUser(data)
  }

  toggleCancel() {
    this.setState({
      cancelAccountOpen: !this.state.cancelAccountOpen
    })
  }

  toggleDeleteUser() {
    this.setState({
      deleteAccountOpen: !this.state.deleteAccountOpen
    })
  }

  deleteUser() {
    //create UserDelete
    console.log('to do - create userdelete')

    $.ajax({
      url: `../request_full_delete`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          deleteSuccessful: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  accountCancelled() {
    let data = {
      user: {
        cancel_reason: this.state.cancelReason,
        status: 'Cancelled'
      }
    }

    this.updateUser(data)

    this.setState({
      accountCancelled: true
    })
  }


  render() {
    if(this.state.deleteSuccessful) {
      return(
        <div style={{maxWidth: 450, margin: 'auto', marginTop: 50}}>
          <div style={{padding: 10}}>
            <h3 className="red bold">Delete account initiated.</h3>
            <h4
              className="lightGrey"
              style={{marginBottom: 20, marginTop: 20}}>
              Thanks for using Lexody! Have a great day :)
            </h4>
          </div>
        </div>
      )
    } else if(this.state.pauseAccountOpen) {
      return(
        <div style={{maxWidth: 450, margin: 'auto'}}>
          <div
            onClick={() => this.togglePause()}
            className="clickable"
            style={{display: 'flex', flexDirection: 'row', marginTop: 40, marginBottom: 30, marginLeft: 10}}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="lightBlue"
              style={{fontSize: 16, marginRight: 10}}
            />
            <h3>Back</h3>
          </div>
          <div className="greyDivider" />
          <div style={{padding: 10}}>
            <h3 className="darkBlue bold">Success! You’re taking a break.</h3>
            <div className="takeABreakImage"></div>
            <h4
              className="lightGrey"
              style={{marginBottom: 20}}>Your profile is still active, but you will not appear in matches for other people, and you won’t receive any emails from us (unless someone messages you directly)</h4>

            <h4 className="lightGrey">When you’re ready to dive back in, just reactivate your account!  Take as long as you need. We’ll be here when you come back!</h4>
            <div style={{textAlign: 'center'}}>
              <BtnPrimary
                onClick={() => this.unpause()}
                buttonText="Reactivate account"
                loading={false}
              />
            </div>
          </div>
        </div>
      )
    } else if(this.state.unpauseAccountOpen) {
      return(
        <div style={{maxWidth: 450, margin: 'auto'}}>
          <div
            onClick={() => this.togglePause()}
            className="clickable"
            style={{display: 'flex', flexDirection: 'row', marginTop: 40, marginBottom: 30, marginLeft: 10}}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="lightBlue"
              style={{fontSize: 16, marginRight: 10}}
            />
            <h3>Back</h3>
          </div>
          <div className="greyDivider" />
          <div style={{padding: 10}}>
            <h3 className="darkBlue bold">I’m back and stronger than ever!</h3>
            <div className="unpauseImage"></div>
            <h4
              className="lightGrey"
              style={{marginBottom: 20}}>Ready to rock n’ roll? You’re account is fully active again!</h4>
            <div style={{textAlign: 'center'}}>
              <BtnPrimary
                onClick={() => window.location.assign('/friends')}
                buttonText="See my matches"
                loading={false}
              />
            </div>
          </div>
        </div>
      )
    } else if (this.state.accountCancelled) {
      return(
        <div style={{maxWidth: 450, margin: 'auto', marginTop: 50}}>
          <div style={{padding: 10}}>
            <h3 className="red bold">Account successfully cancelled.</h3>
            <h4
              className="lightGrey"
              style={{marginBottom: 20, marginTop: 20}}>
              Thanks for using Lexody! Have a great day :)
            </h4>
          </div>
        </div>
      )
    } else if (this.state.deleteAccountOpen) {
      return(
        <div style={{maxWidth: 450, margin: 'auto'}}>
          <div
            onClick={() => this.toggleDeleteUser()}
            className="clickable"
            style={{display: 'flex', flexDirection: 'row', marginTop: 40, marginBottom: 30, marginLeft: 10}}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="lightBlue"
              style={{fontSize: 16, marginRight: 10}}
            />
            <h3>Back</h3>
          </div>
          <div className="greyDivider" />
          <div style={{padding: 10}}>
            <h3 className="red bold">Delete account.</h3>
            <h4
              className="lightGrey"
              style={{marginBottom: 20, marginTop: 20}}>
              This will take up to 30 days. This option will delete all your identifying data. Please read our terms of use to understand more. This is NOT RECOVERABLE. Once requested, you will never, ever, ever, be able to recover this account.
              <br/><br/>
              Like, never. Seriously.
            </h4>
            <div style={{textAlign: 'center'}}>
              <BtnPrimary
                onClick={() => this.accountCancelled()}
                buttonText="Nevermind, just cancel the account now."
                loading={false}
                alert={true}
              />
              <button
                onClick={() => this.deleteUser()}
                style={{marginTop: 20}} className="red">I still want a full delete of my data.</button>
            </div>
          </div>
        </div>
      )
    } else if(this.state.cancelAccountOpen) {
      return(
        <div style={{maxWidth: 450, margin: 'auto'}}>
          <div
            onClick={() => this.toggleCancel()}
            className="clickable"
            style={{display: 'flex', flexDirection: 'row', marginTop: 40, marginBottom: 30, marginLeft: 10}}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="lightBlue"
              style={{fontSize: 16, marginRight: 10}}
            />
            <h3>Back</h3>
          </div>
          <div className="greyDivider" />
          <div style={{padding: 10}}>
            <h3 className="red bold">Cancel account.</h3>
            <h4
              className="lightGrey"
              style={{marginBottom: 20, marginTop: 20}}>
              If you’re done forever, you can cancel your account immediately. You will not receive emails, people can not access your profile or message you.
            </h4>
            <SettingsLongTextInput
              value={this.state.cancelReason}
              label=""
              attribute={'cancelReason'}
              placeholder="How can Lexody be better? Give us any feedback you’d like, so we can improve for future members!"
              onChange={(value, attribute) => this.setState({[attribute]: value})}
            />
            <div style={{textAlign: 'center'}}>
              <BtnPrimary
                onClick={() => this.accountCancelled()}
                buttonText="Cancel account"
                loading={false}
                alert={true}
              />
              <button
                onClick={() => this.toggleDeleteUser()}
                style={{marginTop: 20}} className="red">Request a full delete of my account</button>
            </div>
          </div>
        </div>
      )
    }  else {
      return(
        <div style={{maxWidth: 450, margin: 'auto'}}>
          <div
            onClick={() => this.props.togglePauseContainer()}
            className="clickable"
            style={{display: 'flex', flexDirection: 'row', marginTop: 40, marginBottom: 30, marginLeft: 10}}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="lightBlue"
              style={{fontSize: 16, marginRight: 10}}
            />
            <h3>Settings</h3>
          </div>
          <div className="greyDivider" />
          <div
            onClick={() => this.pauseAccount()}
            className="clickable"
            style={{padding: 10}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <h3 className="lightBlue bold">Pause account</h3>
              <FontAwesomeIcon
                icon={faArrowRight}
                className="lightBlue"
                style={{fontSize: 16, marginRight: 10}}
              />
            </div>
            <h4 className="lightGrey" style={{marginTop: 15}}>Need to take a break from Lexody? Save your progress, and come back when you’re ready! You won’t be shown as a match to other members. You also won’t receive any emails, unless people message you directly.</h4>
          </div>
          <div className="greyDivider" />
          <div
            onClick={() => this.toggleCancel()}
            className="clickable"
            style={{padding: 10}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <h3 className="red bold">Cancel account</h3>
              <FontAwesomeIcon
                icon={faArrowRight}
                className="red"
                style={{fontSize: 16, marginRight: 10}}
              />
            </div>
            <h4 className="lightGrey" style={{marginTop: 15}}>If you’re done forever, you can cancel your account immediately. You will not receive emails, people can not access your profile or message you.</h4>
          </div>
          <div className="greyDivider" />
        </div>
      )
    }
  }

}

export default PauseOrCancelAccount
